module.exports = __webpack_public_path__ + "img/examListBg3.ce09ff68.png";